import React, {Component} from 'react';
import PriceListingRow from "../PriceListingRow";

class SummaryArticleListing extends Component {

    render() {

        const {cartSummary} = this.props;

        return (
            <div className={"summary-step__articles"}>
                {cartSummary.baseArticleInCart ? <div className={"summary-step__articles__article"} key={cartSummary.baseArticle.articleNumber}>
                    {cartSummary.baseArticle.priceMonthly || cartSummary.baseArticle.setupFee ? <PriceListingRow
                        title={cartSummary.baseArticle.title}
                        price={cartSummary.baseArticle.priceMonthly ? Number(cartSummary.baseArticle.priceMonthly).toFixed(2) + " €" : Number(cartSummary.baseArticle.setupFee).toFixed(2) + " €"}
                        monthly={!!cartSummary.baseArticle.priceMonthly}
                        tax={true}
                        caption={cartSummary.baseArticle.description}
                    /> : null}
                    {cartSummary.baseArticle.priceMonthly && cartSummary.baseArticle.setupFee ? <PriceListingRow
                        className={"summary-step__articles__article--setup"}
                        title={"Einrichtungsgebühr"}
                        price={Number(cartSummary.baseArticle.setupFee).toFixed(2) + " €"}
                        tax={true}
                        caption={cartSummary.baseArticle.title}
                    /> : null}
                </div> : null}
                {cartSummary.articleOptions.map(articleOption => {
                    return (
                        <div className={"summary-step__articles__article"} key={articleOption.articleNumber}>
                            {articleOption.priceMonthly || articleOption.setupFee  ? <PriceListingRow
                                title={articleOption.title}
                                price={articleOption.priceMonthly ? Number(articleOption.priceMonthly).toFixed(2) + " €": Number(articleOption.setupFee).toFixed(2) + " €"}
                                monthly={!!articleOption.priceMonthly}
                                tax={true}
                                caption={(articleOption.priceMonthly && articleOption.inclusiveStorage) ? ((articleOption.inclusiveStorage / 1024 / 1024) + " GB inkl.") : articleOption.description}
                            /> : null}
                            {articleOption.priceMonthly && articleOption.setupFee ? <PriceListingRow
                                className={"summary-step__articles__article--setup"}
                                title={"Einrichtungsgebühr"}
                                price={Number(articleOption.setupFee).toFixed(2) + " €"}
                                tax={true}
                                caption={articleOption.title}
                            /> : null}
                            {!articleOption.setupFee && !articleOption.priceMonthly ? <PriceListingRow
                                className={"summary-step__articles__article"}
                                title={articleOption.title}
                                price={"0.00 €"}
                                monthly={true}
                                tax={true}
                                caption={articleOption.inclusiveStorage ? ((articleOption.inclusiveStorage / 1024 / 1024) + " GB inkl.") : ""}
                            /> : null}
                        </div>
                    )
                })}
                {cartSummary.backupRange ? <div className={"summary-step__articles__article"}><PriceListingRow
                    title={cartSummary.backupRange + (cartSummary.backupRange > 1 ? " Tage Backup" : " Tag Backup")}
                    caption={""}
                    price={"kostenfrei"}
                    hint={"in Speicherplatz enthalten"}
                /></div> : null}
            </div>
        );
    }
}

export default SummaryArticleListing;



/** WEBPACK FOOTER **
 ** ./src/components/summary/SummaryArticleListing.js
 **/